<template>
  <el-container class="content" style="display: block;">

	<el-container class="lables">

		<el-row  class="la-list">
			<el-col :span="10" class="first">
				<el-row>
					<div class="search">
						<input type="text" v-model="searchF" @change="loadData()"/>
					</div>
				</el-row>
				<el-row class="lable-o-l lable-o-ls" v-for="(item,index) in lableFirst" :key="index">
					<div class="lable-o" :class="{'choses':choseAF.indexOf(item.l_id)>-1&&item.l_id!=choses,'chosess':item.l_id==choses}"  @click="chose(item.name,item.l_id,item.keynum)">
          {{item.name}}
          </div>

				</el-row>
			</el-col>
			<el-col :span="4" class="centr"><img  src="../../assets/image/next.jpg"/></el-col>
			<el-col :span="10" class="two">
				<el-row>
					<div class="search">
						<input type="text"  v-model="searchT" @change="loadDataTwo()"/>
					</div>
					<div class="add" @click="add()" v-if="this.$store.getters.getRole == 'entry'|| this.$store.getters.getRole == 'admin'|| this.$store.getters.getRole == 'admins' || this.$store.getters.getRole == 'fenxi'">+ 添加</div>
				</el-row>
				<el-row class="lable-o-l">
					<div v-for="(item,index) in lableTwo" style="position: relative;">
					  <div class="lable-two">
					  {{item.name}}
					  </div>
					  <i @click="del(item.id,index)"  style="position: absolute;right: -20px;bottom: 5px;">X</i>
					</div>

				</el-row>
			</el-col>
		</el-row>

	</el-container>
	 <el-dialog
	  title="添加"
	  :visible.sync="centerDialogVisible"
	  width="30%"
	  center>
    <div style="margin-bottom: 15px;">{{addT}}</div>
    <input  type="text" v-focus="picFocusStatus" @input="changeInput1()" class="s_or_x" v-model="addT1"/>
    <input v-if="keynum > 1" type="text" v-focus="picFocusStatus" @input="changeInput2()" class="s_or_x" v-model="addT2"/>
    <input v-if="keynum > 2" type="text" v-focus="picFocusStatus" @input="changeInput3()" class="s_or_x" v-model="addT3"/>

	  <span slot="footer" class="dialog-footer">
		<el-button @click="centerDialogVisible = false">取 消</el-button>
		<el-button type="primary" @click="doAdd()">确 定</el-button>
	  </span>
	</el-dialog>
	<el-dialog
	  title="提示"
	  :visible.sync="dialogVisible"
	  width="30%"


	  <span slot="footer" class="dialog-footer">
		<el-button @click="dialogVisible = false">取 消</el-button>
		<el-button type="primary" @click="doAdds()">确 定</el-button>
	  </span>
	</el-dialog>
  </el-container>
</template>

<script>

  export default {
    data() {
      return {
        lableFirst:[],
		lableTwo:[],
		chosesT:0,
		choses:0,
		choseAF:[],
		choseAT:[],
		searchF:'',
		searchT:'',
		lable:[],
		lableEx:'',
    sx:1,
    ss:0,
    keynum:0,
		centerDialogVisible:false,
		addType:0,
		picFocusStatus:false,
    addName:'',
    addT:'',
		addT1:'',
    addT2:'',
    addT3:'',
		dialogVisible: false,
		acp:'',
		addcf:0,
		token:window.localStorage.getItem('token'),
		userId:window.localStorage.getItem('id'),
		url:this.$store.getters.getUrl
      };
    },
	directives: {
		focus: {
		  inserted: function(el, { value }) {
			if (value) {
			  el.focus();
			}
		  }
		}
    },
    created() {
      this.loadData();

    },

	methods:{
    del(id,index){
      const axiosInstance = this.$axios.create({
      	headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
      	withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
      });
      axiosInstance({
      	method:'post',
      	params:{
      		id:id,
      	},
      	url:'http://fencip.yoooooo.com/index.php/index/data/keysdel'
      })
      .then(res=>{
      	if(res.data.code == 200){

          this.lableTwo.splice(index,1)

      	}else{
      		alert('删除失败')
      	}

      })
      .catch(err=>{

      });
    },
		loadData(){

			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchF
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/keysFirst'
			})
			.then(res=>{
				this.lableFirst = res.data;

			})
			.catch(err=>{

			});
		},
		loadDataTwo(){
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
			axiosInstance({
				method:'get',
				params:{
					name:this.searchT,
					p_id:this.choses
				},
				url:'http://fencip.yoooooo.com/index.php/index/data/keysTwo'
			})
			.then(res=>{
				this.lableTwo = res.data;

			})
			.catch(err=>{

			});
		},
		chose(addName,id,keynum){
      this.addName = addName;
      this.addT = addName;
			this.choses = id;
      this.keynum = keynum;
			this.searchT = '';
			this.loadDataTwo();

		},

    changeInput1(){
      if(this.addT1){
        this.addT =  this.addName+'('+this.addT1+')'
      }else{
        this.addT =  this.addName
      }

      this.addT2 = ''
      this.addT3 = ''
    },
    changeInput2(){
      if(this.addT2){
        this.addT =  this.addName+'('+this.addT1+')'+'('+this.addT2+')'
      }else{
        this.addT =  this.addName+'('+this.addT1+')'
      }
      
      this.addT3 = ''
    },
    changeInput3(){
      if(this.addT3){
        this.addT =  this.addName+'('+this.addT1+')'+'('+this.addT2+')'+'('+this.addT3+')'
      }else{
        this.addT =  this.addName+'('+this.addT1+')'+'('+this.addT2+')'
      }
      
    },
		add(){

			this.centerDialogVisible = true;
			this.picFocusStatus = true

		},
		msg(msg,type){
			this.$message({
			  message: msg,
			  type: type
			});
		},
		doAdd(){
			let p_id = this.choses;
			const axiosInstance = this.$axios.create({
				headers: {'Content-Type': 'application/json;charset=utf-8'},// 设置传输内容的类型和编码
				withCredentials: true,// 指定某个请求应该发送凭据。允许客户端携带跨域cookie，也需要此配置
			});
      let step = 0
      if(this.addName == ''){
        this.msg('请选择功能分类','error')
        return false
      }

      if(this.addT3 == ''){
        step = 2
      }else{
        step = 3
      }
      if(this.addT2 == ''){
        step = 1
      }
      if(this.addT1 == ''){
        step = 0
      }
      if(step == 0){
        this.msg('内容不能为空','error')
        return false
      }

			axiosInstance({
				method:'post',
				params:{
					step:step,
					name:this.addT,
          key1:this.addT1,
          key2:this.addT2,
          key3:this.addT3,
					l_id:p_id,

				},
				url:'http://fencip.yoooooo.com/index.php/index/data/keysAdd'
			})
			.then(res=>{

				if(res.data.code == 200){
					this.centerDialogVisible = false;
					this.addT = this.addName;
          this.addT1 = '';
          this.addT2 = '';
          this.addT3 = '';
					this.dialogVisible = false
					this.loadDataTwo();

				}else{
					this.centerDialogVisible = false;
					this.addT = '';

					alert('添加失败')
				}

			})
			.catch(err=>{

			});
		},

	}


  }
</script>

<style>

	.content{
		background: #939AA0;
		width: 100%;
		height: 100%;
	}
	.centr{
		margin-top: 30%;
	}
	.centr img{
		width: 100px;
		height: 50px;
		margin-left: 35px;
	}

	.zhuyi{
		color: red;
    margin-left: 120px;
    font-size: 20px;
	}
	.butn{
		color: #F0F8FF;
		background: #FF9400;
		margin-right: 20px;
		border-radius: 5px;
		width: 50px;
	}
	.lables{
		margin-left: 5%;
		margin-right: 5%;
		background: #fff;
		padding-bottom: 35px;
	}
	.lables .la-list{
		margin-top: 50px;
		width: 100%;
		margin-left: 20%;
		margin-right: 20%;
	}
	.first{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.first .el-row{
		margin: 20px 10% 20px 10%;
	}
	.search input{
		width: 95%;
		height: 20px;
		margin-bottom: 10px;
		margin-left: 2%;
	}
	.add{
		text-align: center;
		width: 96%;
		background: #c6c6c6;
		height: 22px;
		line-height: 22px;
		margin-left: 2%;
	}

	.lable-o{
		width: 47%;
		text-align: center;
		background: #c6c6c6;
		height: 30px;
		line-height: 30px;
		margin-bottom: 10px;
	}
	.lable-two{

		text-align: center;
		background: #c6c6c6;

		line-height: 30px;
		margin-bottom: 10px;
	}
	.choses{
		background: #f8f1da;
	}
	.chosess{
		background: #ff9400;
	}
	.right{
		float: right;
	}
	.left{
		float: left;
	}
	.two{
		border: 1px solid #c6c6c6;
		height: 850px;
		overflow-y:scroll;
	}
	.two .el-row{
		margin: 20px 10% 20px 10%;
	}
	.searchTsx{
		width: 30%;
		margin-left: 10%;
		height: 30px;
	}
  .s_or_x{
    width: 20%;
    height: 35px;
  }
	.lable-o-ls{
		border-bottom: 1px solid #c6c6c6;
	}
</style>



// WEBPACK FOOTER //
// src/components/main/keys.vue